<template>
  <div><h1>크램스쿨</h1></div>

  <div class="ma-12">크램스쿨(CramSchool)은 학원, 유치원,학교를 위한 소규모 커뮤니티 앱 입니다.

    크램스쿨은 학원코드를 제공하여, 동일한 학원코드를 보유한 선생님과 학부모 및 학생을 자동으로 친구 연결을 해주며,
    채팅 기반의 실시간 알람장 및 게시판으로 활용할수 있습니다.
    특히 "진실의방"은 온라인 화상통화 기능  화상 통화 기능을 제공하여 보다 활발한 커뮤니케이션을 가능하게 합니다.
    소규모 학원및 유치원등을 운영하시는 분들에게 학원 홍보및 운영앱으로 적합합니다.

    크램스쿨(CramSchool)의 모든 채팅 메세지는 모바일 폰 내에 일체 저장하지 않으며,
    암호화하여 서버측에 임시 저장 되므로 보안용 채팅앱으로도 사용 가능합니다.
    크램스쿨(CramSchool)은 종단간암호화(추후지원)를 구현합니다.</div>
  <div>
    <h1>앱 지원</h1>
    <p>앱 관련 문의사항이 있으시면 아래 이메일로 연락주세요:</p>
    <p><a href="mailto:swlee@u2ware.com">swlee@u2ware.com</a></p>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
